import { useContext } from "react";
import { Route, Routes } from "react-router-dom";

import { AppRulesContext } from "../App";
import GuardedRoute from "../components/GuardedRoute";
import PageNotFound from "../pages/PageNotFound";
import UserDetails from "../pages/users/UserDetails";
import Users from "../pages/users/Users";

const UserNavigator = () => {
  const { rulesSvc } = useContext(AppRulesContext);

  return (
    <Routes>
      <Route
        index
        path=""
        element={<GuardedRoute rules={rulesSvc.usersList} element={<Users />} />}
      />

      <Route
        path=":uUId"
        element={<GuardedRoute rules={rulesSvc.updateUser} element={<UserDetails />} />}
      />
      {/* URL Not Found */}
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default UserNavigator;
